module.exports = __webpack_public_path__ + "img/1516882070.af2a7b4d.jpg";